<template>
  <div id="app" v-bind:class="appClass">
    <Toast/>
    <header>
      <NavBar :on-top="navBarTop" :current="appClass"></NavBar>
    </header>
    <main id="content" v-on:scroll="handleScroll">
      <Home id="home"></Home>
      <Profile id="profile"></Profile>
      <Services id="services"></Services>
      <Skills id="skills"></Skills>
      <Resume id="resume"></Resume>
      <Contact id="contact"></Contact>
    </main>
  </div>
</template>

<script>
  import 'primevue/resources/themes/nova-light/theme.css';
  import 'primevue/resources/primevue.min.css';
  import 'primeicons/primeicons.css';
  import NavBar from '../components/NavBar';
  import Home from './home';
  import Profile from './profile';
  import Services from './services';
  import Skills from './skills';
  import Resume from './resume';
  import Contact from './contact';
  import Toast from 'primevue/toast';

  export default {
    name: 'app',
    data: () => {
      return {
        navBarTop: true,
        appClass: 'home'
      }
    },
    components: {
      NavBar,
      Toast,
      Home,
      Profile,
      Services,
      Skills,
      Resume,
      Contact,
    },
    methods: {
      handleScroll (event) {
        this.navBarTop = event.target.scrollTop < 150;
        if (event.target.scrollTop < document.getElementById('profile').offsetTop) {
          this.appClass = 'home';
        } else if (event.target.scrollTop < document.getElementById('services').offsetTop) {
          this.appClass = 'profile';
        } else if (event.target.scrollTop < document.getElementById('skills').offsetTop) {
          this.appClass = 'services';
        } else if (event.target.scrollTop < document.getElementById('resume').offsetTop) {
          this.appClass = 'skills';
        } else if (event.target.scrollTop < document.getElementById('contact').offsetTop) {
          this.appClass = 'resume';
        } else {
          this.appClass = 'contact';
        }
      }
    }
  }
</script>

<style lang="scss">
  @import 'src/assets/styles/variables';
  html {
    height: 100vh;
    overflow: hidden;
    & * {
      margin: 0;
      padding: 0;
      font-family: "Open Sans", "Helvetica Neue", sans-serif;
    }
  }

  .btn-default {
    color: $mainColor;
    background-color: transparent;
    font-weight: 400;
    border: 2px solid #25BAD0;
    padding: 12px 20px;
    margin: 0;
    font-size: 15px;
    border-radius: 0;
    text-transform: uppercase;
    cursor: pointer;
    &:hover {
      color: $secondaryColor;
      background-color: $mainColor;
    }
  }

  .page-title {
    line-height: 40px;
    color: $white;
    margin: 10px 0 30px 0;
    font-size: 40px;
    font-weight: 400;
    text-transform: uppercase;
    padding-bottom: 10px;
  }
  .page-title.light {
    color: $mainColor;
  }

  .page {
    padding: 100px 10vw 50px 10vw;
    min-height: 100vh;
  }

  #app {
    &:before {
      content: "";
      position: absolute;
      top: 0; left: 0;
      width: 100%; height: 100%;
      filter: contrast(30%) brightness(50%);
      z-index: -1;
    }
    &.home:before {
      background-image: url('../assets/img/code_home.png');
    }
    &.profile:before, &.services:before {
      background-image: url('../assets/img/code_services.png');
    }
    &.skills:before, &.resume:before {
      background-image: url('../assets/img/code_resume.png');
    }

    header {
      position: fixed;
      top: 0;
      z-index: 99999;
    }

    #content {
      height: 100vh;
      overflow-y: scroll;
    }
  }

  /* mobile */
  @media (max-width: 640px) {
    .page {
      padding: 100px 10px 50px 10px;
    }

    .page-title {
      line-height: 30px;
      font-size: 30px;
    }
  }
</style>
